// extracted by mini-css-extract-plugin
export default {"formControl":"Switch_formControl__Dybk-","off":"Switch_off__zq2ZV"};